/* COPY CART TO CLIPBOARD logic
  Includes Auto-Injector for Ajax Carts & Terms Validation
*/

async function copyCartToClipboard() {
  // FINAL SAFETY CHECK: Scope the check to the visible container
  // This prevents finding the "Ghost" checkbox on the static cart page
  const activeDrawer = document.querySelector('#CartDrawer.is-active, .drawer--active, .drawer.active');
  let checkbox;
  
  if (activeDrawer) {
    // If drawer is open, only accept the checkbox INSIDE the drawer
    checkbox = activeDrawer.querySelector('input[type="checkbox"][id*="Agree"]');
  } else {
    // Otherwise, accept the static page checkbox
    checkbox = document.getElementById('CartPageAgree') || document.getElementById('CartAgree');
  }

  // If a checkbox exists and is NOT checked, block the action
  if (checkbox && !checkbox.checked) {
      alert("Please agree to the Terms and Conditions first.");
      return; 
  }

  try {
    // 1. Fetch the latest cart data
    const response = await fetch('/cart.js');
    const cart = await response.json();

    // 2. Logic to determine "Ships From" based on URL
    const hostname = window.location.hostname.toLowerCase();
    let shipsFrom = 'C3 Canada'; // Default
    if (hostname.includes('c3powersportsusa.com')) {
        shipsFrom = 'Idaho';
    }

    // 3. Start building HTML
    // -- PREAMBLE SECTION --
    let html = `<div style="font-family: sans-serif; margin-bottom: 15px;">Hi C3 team - we'd like to order the below on our dealer account:<br>[please add any other comments here if you have any!]</div>`;

    // -- PREAMBLE TABLE (3x2) --
    html += `<table border="1" cellspacing="0" cellpadding="3" style="border-collapse: collapse; font-family: sans-serif; border: 1px solid #ccc; margin-bottom: 20px;">
      <tr>
        <td style="width: 200px; font-size: 7pt; background-color: #f0f0f0; vertical-align: middle;text-align:right;line-height: 1.1;">
          If you're sending this from a different email than the one we have on your dealer account, please confirm which dealership you're ordering for:
        </td>
        <td style="width: 150px;">&nbsp;</td>
      </tr>
      <tr>
        <td style="width: 200px; background-color: #f0f0f0;text-align:right; vertical-align: middle;">Dealer PO#:</td>
        <td style="width: 150px; vertical-align: middle;">&nbsp;</td>
      </tr>
      <tr>
        <td style="width: 200px; background-color: #f0f0f0;text-align:right; vertical-align: middle;">Ships from:</td>
        <td style="width: 150px; vertical-align: middle;"> ${shipsFrom}</td>
      </tr>
    </table>`;

    // -- CART TABLE --
    html += '<table border="1" cellspacing="0" cellpadding="3" style="border-collapse: collapse; font-family: sans-serif; border: 1px solid #ccc;">';
    
    html += `
      <thead>
        <tr style="background-color: #f0f0f0;">
          <th style="width: 270px; text-align: left; vertical-align: middle;">Description</th>
          <th style="width: 70px; text-align: left; vertical-align: middle;">Retail price (ea)</th>
          <th style="width: 160px; text-align: left; vertical-align: middle;">SKU</th>
          <th style="width: 40px; text-align: center; vertical-align: middle;">Qty</th>
        </tr>
      </thead>
      <tbody>`;

    const clean = (str) => {
        if (!str) return '';
        return str.replace(/\(D#[A-Z0-9]+\)/g, '').trim();
    };

    // Helper for CSV Escaping (wraps in quotes if contains comma)
    const csvEscape = (str) => {
        if (!str) return '';
        const cleaned = clean(str);
        if (cleaned.includes(',') || cleaned.includes('"')) {
            return `"${cleaned.replace(/"/g, '""')}"`;
        }
        return cleaned;
    };

    // Prepare CSV Data Container
    // 'csvBlock' is for the Email Body (includes Markdown ** for bolding)
    let csvBlock = "\n\n--- Below here is the item list in CSV format for uploading the order ---\n\n**ItemNumber,**Qty\n";
    
    // 'fileCsvContent' is for the Actual File Download (Clean, no markdown)
    let fileCsvContent = "ItemNumber,Qty\n";

    cart.items.forEach(item => {
      // 1. Build HTML Description
      let description = `<strong>${clean(item.product_title)}</strong>`;
      
      if (item.variant_title && item.variant_title !== 'Default Title') {
         const variantTitle = clean(item.variant_title);
         if (variantTitle) {
            description += ` <br><span style="color:#666; font-size: 90%;">${variantTitle}</span>`;
         }
      }

      if (item.properties) {
        for (const [key, value] of Object.entries(item.properties)) {
            if (key.startsWith('_') || !value) continue;
            const cleanVal = clean(value);
            if (cleanVal) {
                description += `<span style="font-size: 85%; font-style: italic;">, ${key}: ${cleanVal}</span>`;
            }
        }
      }

      const price = (item.price / 100).toFixed(2);
      const sku = item.sku || '';

      // 2. Add to HTML Table
      html += `
        <tr>
          <td style="width: 270px; font-size: 7pt; vertical-align: middle;">
            ${description}
          </td>
          <td style="width: 70px; vertical-align: middle;">$${price}</td>
          <td style="width: 160px; vertical-align: middle;">${sku}</td>
          <td style="width: 40px; text-align: center; vertical-align: middle;">${item.quantity}</td>
        </tr>`;

      // 3. Add to CSV Data
      // Email Body Version
      csvBlock += `${csvEscape(sku)},${item.quantity}\n`;
      
      // File Download Version (Clean)
      fileCsvContent += `${csvEscape(sku)},${item.quantity}\n`;
    });

    html += '</tbody></table>';

    // -- POST-AMBLE SECTION --
    html += `<div style="font-family: sans-serif; margin-top: 20px; color: #555; font-size: 8pt;">
      FAQ: What's our dealer cost for each item? A: Not available here sorry - it will be generated after the order is entered into C3's system, and you will receive an automated email with the invoice attached (which shows the dealer cost clearly).<br>
      <br>
      Thanks for your business!
    </div>`;

    // -- CSV BLOCK (HTML Version) --
    // This appends the CSV data visually to the bottom of the email with the requested styling
    const htmlCsvContent = csvBlock.replace(/\n/g, '<br>');
    html += `<div style="font-family: monospace; font-size: 7pt; color: #cccccc; margin-top: 30px; border-top: 1px dashed #eee; padding-top: 10px;">
        ${htmlCsvContent}
    </div>`;

    // 4. Create the Clipboard Item
    const blobHtml = new Blob([html], { type: 'text/html' });
    
    // Create Plain text fallback version
    const plainTextPreamble = `Hi C3 team - we'd like to order the below:
[please add any other comments here if you have any!]

Dealership (if different from file): ________________
Our internal PO ref#: ________________
Ships from: ${shipsFrom}

--------------------------------
`;

    const plainTextPostamble = `

What's our dealer cost for each item? Not available here sorry - it will be generated after the order is entered into our system, and you will receive an automated email with the invoice attached (which shows the dealer cost clearly).
Thanks for your business!`;

    // Combine Preamble + List + Postamble + CSV Block
    const blobText = new Blob([
        plainTextPreamble + 
        cart.items.map(i => `${i.quantity}x ${clean(i.title)}`).join('\n') + 
        plainTextPostamble + 
        csvBlock
    ], { type: 'text/plain' });

    const clipboardItem = new ClipboardItem({
      'text/html': blobHtml,
      'text/plain': blobText
    });

    await navigator.clipboard.write([clipboardItem]);

    // 5. Feedback: Show a Success Message Box
    const btns = document.querySelectorAll('.share-cart-btn');
    btns.forEach(btn => {
        const parent = btn.closest('.share-cart-wrapper') || btn.parentNode;
        
        const existing = parent.querySelector('.copy-cart-feedback');
        if (existing) existing.remove();

        const div = document.createElement('div');
        div.className = 'copy-cart-feedback';
        
        // REVERTED: Standard Block Flow (pushes content down)
        div.style.cssText = `
            margin-top: 7px; 
            padding: 0; 
            background-color: white; 
            border: 1px solid #ccc; 
            border-radius: 4px; 
            font-size: 13px; 
            text-align: center;
            line-height: 1.4;
            overflow: hidden;
            box-shadow: 0 2px 5px rgba(0,0,0,0.05);
        `;
        
        div.innerHTML = `
            <div style="padding: 10px; background-color: #e8f5e9; border-bottom: 1px solid #a5d6a7; color: #2e7d32;">
                <strong>Copied!</strong>
                If you are a <strong>dealership</strong>, you can paste it into an email to 
                <a href="mailto:orders@c3powersports.com" target="_blank" style="color: #1b5e20; text-decoration: underline; font-weight: bold;">orders@c3powersports.com</a>
                <br><span style="font-size: 11px; color: #555; display: block; margin-top: 4px;">(Dealers ONLY please - all website-direct customers MUST proceed through checkout)</span>
            </div>
            <div style="padding: 10px; background-color: #e3f2fd; color: #0d47a1; font-size: 12px;">
                <strong>OR</strong> if you want to get your order in front of our shipping team even quicker (& are keen to help us out (thanks!)):<br>
                <a href="#" id="c3-download-csv-link" style="color: #0d47a1; text-decoration: underline; font-weight: bold; cursor: pointer;">Click here to download cart as CSV instead</a>, 
                and <a href="/pages/dealer-order-upload" target="_blank" style="color: #0d47a1; text-decoration: underline; cursor: pointer;">click here for instructions</a> how to upload it into our system yourself (very easy!)
            </div>
        `;
        
        if (btn.nextSibling) {
            parent.insertBefore(div, btn.nextSibling);
        } else {
            parent.appendChild(div);
        }

        // ADDED: Scroll the feedback into view smoothly
        div.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // CSV Download Logic
        const dlLink = div.querySelector('#c3-download-csv-link');
        if (dlLink) {
            dlLink.onclick = (e) => {
                e.preventDefault(); 
                const blob = new Blob([fileCsvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute("href", url);
                link.setAttribute("download", `C3_Order_${new Date().toISOString().slice(0,10)}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
        }

        // Auto-remove after 25 seconds
        setTimeout(() => {
            if (div.parentNode) div.remove();
        }, 25000);
    });

  } catch (err) {
    console.error('Failed to copy cart:', err);
    alert('Could not copy cart. Please try again.');
  }
}

/* HELPER: Terms & Conditions Logic */
function setupTermsLogic(btn) {
  // 1. DETERMINE CONTEXT by looking up the DOM tree
  const drawerContainer = btn.closest('#CartDrawer') || btn.closest('.drawer') || btn.closest('.ajaxcart__footer');
  
  let checkbox;
  
  if (drawerContainer) {
    checkbox = drawerContainer.querySelector('input[type="checkbox"][id*="Agree"]');
  } else {
    checkbox = document.getElementById('CartPageAgree') || document.getElementById('CartAgree');
  }

  if (!checkbox) return;

  const toggle = () => {
    btn.disabled = !checkbox.checked;
    if (btn.disabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
    } else {
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
    }
  };

  toggle();
  checkbox.addEventListener('change', toggle);
}


/* AUTO-INJECTOR */
(function() {
  function injectButton() {
    const footer = document.querySelector('.drawer__footer, .drawer__footer--fixed, #CartDrawer .ajaxcart__footer');
    if (!footer || footer.querySelector('.share-cart-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'share-cart-wrapper';
    
    // REVERTED: Removed position: relative
    Object.assign(wrapper.style, {
        textAlign: 'center',
        paddingTop: '7px',
        width: '100%'
    });

    const orText = document.createElement('span');
    orText.innerText = 'Or ';

    const btn = document.createElement('button');
    btn.className = 'share-cart-btn btn btn--small'; 
    btn.type = 'button';
    btn.innerText = 'Copy Cart to Clipboard';
    btn.onclick = copyCartToClipboard;
    
    wrapper.appendChild(orText);
    wrapper.appendChild(btn);

    const checkoutBtn = footer.querySelector('button[name="checkout"], button[type="submit"]');
    if (checkoutBtn) {
      checkoutBtn.parentNode.insertBefore(wrapper, checkoutBtn.nextSibling);
    } else {
      footer.appendChild(wrapper);
    }

    setupTermsLogic(btn);
  }

  if (window.jQuery) {
    window.jQuery('body').on('updateCart.ajaxcart', function() {
      setTimeout(injectButton, 100); 
    });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    injectButton();
    const staticBtns = document.querySelectorAll('.share-cart-btn');
    staticBtns.forEach(btn => setupTermsLogic(btn));
  });
})();